import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { BOOK_STATUS_LIST } from '../../utils/bookStatusList'

const BookSearchForm = ({ onSubmit }) => {
  return (
    <div className='addBooksForm'>
      <div className='addBooksForm__form'>
        <form onSubmit={onSubmit}>
          <div className='addBooksForm__form-title'>Поиск по книгам</div>
          <Row>
            <Col md={12}>
              <input type='text' name='title' placeholder='Название' />
            </Col>
            <Col md={6}>
              <input type='text' name='author' placeholder='Автор' />
            </Col>
            <Col md={6}>
              <input type='text' name='publisher' placeholder='Издательство' />
            </Col>
            <Col md={6}>
              <input type='text' name='isbn' placeholder='ISBN' />
            </Col>
            <Col md={6}>
              <input type='text' name='udk' placeholder='УДК' />
            </Col>
            <Col md={6}>
              <input type='text' name='year' placeholder='Год издания' />
            </Col>
            <Col md={6}>
              <input type='text' name='bbk' placeholder='ББК' />
            </Col>
            <Col md={6}>
              <input type='text' name='category' placeholder='Категория' />
            </Col>
            <Col md={6}>
              <input type='text' name='discipline' placeholder='Дисциплина' />
            </Col>
            <Col md={6}>
              <select name='status'>
                {BOOK_STATUS_LIST.map(item => {
                  return (
                    <option value={item.value} key={item.value}>
                      {item.name}
                    </option>
                  )
                })}
              </select>
            </Col>
          </Row>

          <button type='submit'>Искать</button>
        </form>
      </div>
    </div>
  )
}

export default BookSearchForm
